import { supabase } from "../supabase/SupabaseClient";

/* Dónde vive un empleado. El dato más personal que guarda el sistema.
 *
 * ── POR QUÉ TIENE TABLA PROPIA Y NO ES UNA COLUMNA MÁS ───────────────────
 *
 * `chofer_documentos` tiene una columna `direccion`, y era el lugar obvio. No
 * va ahí: `services/documentacion.js` la selecciona junto con el resto de la
 * planilla en una pantalla que sólo pide `ver.documentos`. Cargarla ahí no
 * era guardarla, era publicarla en la pantalla que abre medio taller. La
 * columna quedó marcada NO USAR y los datos viven en `empleado_domicilio`, con
 * su propia RLS por `ver.domicilio_chofer` — el mismo camino que `chofer_pin`.
 *
 * ── EL PERMISO ARRANCA SIN NADIE ─────────────────────────────────────────
 *
 * Igna, el 27/08/2026: *«hagamos al revés. Nadie puede verlo… se lo agrego yo
 * a mano a los que lo necesitan»*. No hay rol que lo traiga de arriba: se
 * otorga de a una persona.
 *
 * ── LA RLS FILTRA EN SILENCIO ────────────────────────────────────────────
 *
 * Sin el permiso la consulta no falla: llega vacía, igual que si la persona no
 * tuviera domicilio cargado. Desde acá los dos casos son idénticos, así que
 * quien llama tiene que preguntar ANTES por el permiso —lo tiene en la lista
 * de la sesión— y recién entonces leer el vacío como «no está cargado». Al
 * revés, se le dice «no tiene domicilio» a alguien que sí lo tiene y se manda
 * a cargar de nuevo un dato que ya está.
 */
const limpio = (dni) => String(dni ?? "").replace(/\D/g, "").replace(/^0+/, "");

/* `{dato, error}`, mismo contrato que el resto de los servicios: la ficha
 * tiene que abrir aunque esto falle, y «no se pudo mirar» tiene que poder
 * decirse distinto de «no hay». */
export async function domicilioDe(dni) {
  const d = limpio(dni);
  if (!d) return { dato: null, error: "" };
  try {
    const { data, error } = await supabase
      .from("empleado_domicilio")
      .select("dni,domicilio,piso,dto,localidad,cp,telefono,origen,actualizado_en")
      .eq("dni", d)
      .limit(1);
    if (error) return { dato: null, error: error.message };
    return { dato: data?.[0] || null, error: "" };
  } catch (e) {
    return { dato: null, error: e.message || "No se pudo consultar." };
  }
}

export default domicilioDe;
